import { FC, useCallback } from "react";
import { useSelector } from "react-redux";

import { Divider } from "@livechat/design-system";

import Block from "components/layout/Block";
import Text from "components/layout/Text";
import { IApplication, canManageApplications } from "store/entities/applications";

import { handleDirectInstallationUrlFlow } from "../../../helpers";

interface IProps {
  application: IApplication;
}

const FinishInstallation: FC<IProps> = ({ application }) => {
  const { name, directInstallUrl, clientId } = application;

  const canManageApps = useSelector(canManageApplications);

  const handleFinishInstallation = useCallback(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: any) => {
      e.preventDefault();

      handleDirectInstallationUrlFlow({
        name,
        // @ts-expect-error TS(2322)
        directInstallUrl,
        // @ts-expect-error TS(2322)
        clientId,
      });
    },
    [name, clientId, directInstallUrl]
  );

  if (!directInstallUrl || !canManageApps) {
    return null;
  }

  return (
    <Block marginTop="36px">
      <Divider />
      <Text fontSize="14px" marginTop="16px" lineHeight="20px">
        To have all functions available <strong>{name}</strong> requires the additional direct installation to connect
        with the <strong>{name}</strong> app. If you haven’t click it before, please{" "}
        <a href="#" onClick={handleFinishInstallation}>
          Finish Installation
        </a>
        .
      </Text>
    </Block>
  );
};

export default FinishInstallation;
